'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _next = require('@alifd/next');

var _vuFusionField = require('../common/vu-fusion-field');

var _vuFusionField2 = _interopRequireDefault(_vuFusionField);

var _dateConstants = require('../common/dateConstants');

var _formatter = require('../common/formatter');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var MonthPicker = _next.DatePicker.MonthPicker,
    YearPicker = _next.DatePicker.YearPicker;
var Date = (_temp = _class = function (_Field) {
  _inherits(Date, _Field);

  function Date(props) {
    _classCallCheck(this, Date);

    var _this = _possibleConstructorReturn(this, _Field.call(this, props));

    _this.disabledDate = function (date, view) {
      var currentDate = (0, _moment2.default)();
      var _this$props = _this.props,
          _this$props$disabledD = _this$props.disabledDate;
      _this$props$disabledD = _this$props$disabledD === undefined ? {} : _this$props$disabledD;
      var type = _this$props$disabledD.type,
          format = _this$props.format,
          maxDate = _this$props.maxDate;
      // dd模式G端不可选日期配置对其不生效

      if (format.toLocaleLowerCase() === 'dd' && maxDate) {
        var year = currentDate.year();
        var month = currentDate.month() + 1;
        if (currentDate.daysInMonth() > maxDate) {
          return date > (0, _moment2.default)(year + '-' + month + '-' + maxDate).valueOf();
        } else {
          return false;
        }
      }

      switch (view) {
        case 'date':
          type === _dateConstants.DISABLED_RANGE.beforeToday && currentDate.add(-1, 'days');
          return _this.calculateDisabled(date.valueOf(), currentDate.valueOf());
        case 'year':
          return _this.calculateDisabled(date.year(), currentDate.year());
        case 'month':
          return _this.calculateDisabled(date.year() * 100 + date.month(), currentDate.year() * 100 + currentDate.month());
        default:
          return false;
      }
    };

    _this.calculateDisabled = function (date, current) {
      var _this$props$disabledD2 = _this.props.disabledDate;
      _this$props$disabledD2 = _this$props$disabledD2 === undefined ? {} : _this$props$disabledD2;
      var type = _this$props$disabledD2.type,
          start = _this$props$disabledD2.start,
          end = _this$props$disabledD2.end;

      switch (type) {
        case _dateConstants.DISABLED_RANGE.beforeToday:
          return date < current;
        case _dateConstants.DISABLED_RANGE.afterToday:
          return date > current;
        case _dateConstants.DISABLED_RANGE.duration:
          if (start && end) {
            return date >= (0, _moment2.default)(start).valueOf() && date <= (0, _moment2.default)(end).valueOf();
          }
          return false;
      }
    };

    _this.onVisibleChange = _this.onVisibleChange.bind(_this);
    _this.handleDomFunc = _this.handleDomFunc.bind(_this);
    _this.watchClick = _this.watchClick.bind(_this);
    return _this;
  }

  Date.prototype.getProps = function getProps() {
    return _extends({}, this.props, {
      fieldClassName: 'vc-date'
    });
  };

  Date.prototype.formatOut = function formatOut(value) {
    var _props = this.props,
        clearUnusedTimestamp = _props.clearUnusedTimestamp,
        format = _props.format;

    return (0, _formatter.formatOut)(value, 'Date', { clearUnusedTimestamp: clearUnusedTimestamp, format: format });
  };

  Date.prototype.watchClick = function watchClick() {
    var btnDoms = document.getElementsByClassName('next-calendar-btn');
    setTimeout(function () {
      if (btnDoms[2].title === '十二月') {
        btnDoms[4].style.display = 'none';
      } else if (btnDoms[2].title === '一月') {
        btnDoms[1].style.display = 'none';
      } else {
        btnDoms[4].style.display = 'inline-block';
        btnDoms[1].style.display = 'inline-block';
      }
    }, 0);
  };

  Date.prototype.handleDomFunc = function handleDomFunc(visible) {
    var btnDoms = document.getElementsByClassName('next-calendar-btn');
    var headerDom = document.getElementsByClassName('next-calendar-panel-header');
    if (!btnDoms.length || !headerDom.length) return;
    btnDoms[0].style.display = 'none';
    btnDoms[3].style.display = 'none';
    btnDoms[5].style.display = 'none';
    if (visible) {
      this.watchClick();
      headerDom[0].addEventListener('click', this.watchClick);
    } else {
      headerDom[0].removeEventListener('click', this.watchClick);
    }
  };

  Date.prototype.onVisibleChange = function onVisibleChange(visible) {
    var _this2 = this;

    setTimeout(function () {
      var format = _this2.props.format;

      var lowerCaseFormat = format.toLocaleLowerCase();
      if (lowerCaseFormat === 'mm-dd') {
        _this2.handleDomFunc(visible);
      } else if (lowerCaseFormat === 'dd') {
        var hideDom = document.getElementsByClassName('next-calendar-panel-header');
        if (!hideDom.length) return;
        hideDom[0].style.display = 'none';
      }
    }, 0);
  };

  Date.prototype.renderControl = function renderControl() {
    var commonProps = this.getControlProps();

    var format = this.props.format;


    var fieldProps = _extends({}, commonProps, {
      style: _extends({}, commonProps.style, { width: '100%' }),
      format: _dateConstants.TRANSFORM_FORMAT[format] || format,
      showTime: this.showTime,
      disabledDate: this.disabledDate,
      popupClassName: ['DD'].includes(format.toLocaleUpperCase()) ? 'onlyDayDisplay' : ''
    });

    switch (format) {
      case 'yyyy-MM':
        return _react2.default.createElement(MonthPicker, fieldProps);
      case 'YYYY':
        return _react2.default.createElement(YearPicker, fieldProps);
      default:
        return _react2.default.createElement(_next.DatePicker, _extends({}, fieldProps, { onVisibleChange: this.onVisibleChange }));
    }
  };

  _createClass(Date, [{
    key: 'showTime',
    get: function get() {
      var format = this.props.format;

      if (format === 'yyyy-MM-dd HH:mm') {
        return { format: 'HH:mm' };
      } else if (format === 'yyyy-MM-dd HH:mm:ss') {
        return { format: 'HH:mm:ss' };
      } else {
        return null;
      }
    }
  }]);

  return Date;
}(_vuFusionField2.default), _class.displayName = 'Date', _class.defaultProps = _extends({}, _vuFusionField2.default.defaultProps, {
  hasClear: true
}), _class.defaultMutators = _vuFusionField2.default.defaultMutators, _class.mutableStates = [].concat(_toConsumableArray(_vuFusionField2.default.mutableStates), ['format']), _temp);
exports.default = Date;
module.exports = exports['default'];